// File: frontend/src/contexts/AnalyticsContext.js

import React, { createContext, useContext, useEffect } from 'react';
import AnalyticsService from '../services/AnalyticsService';
import { useGDPRConsent } from './GDPRConsentContext';

const AnalyticsContext = createContext();

export const useAnalytics = () => {
  return useContext(AnalyticsContext);
};

export const AnalyticsProvider = ({ children }) => {
  const { hasConsent } = useGDPRConsent();

  // Initialize analytics service when consent is granted
  useEffect(() => {
    if (hasConsent) {
      AnalyticsService.initialize();
    }
  }, [hasConsent]);

  const trackEvent = (eventName, data = {}) => {
    if (hasConsent) {
      AnalyticsService.trackEvent(eventName, data);
    }
  };

  return (
    <AnalyticsContext.Provider
      value={{
        trackEvent,
        hasAnalyticsConsent: hasConsent
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;